window.cardProductFunc = function () {


  const groupMediaByColor = (productData) => {
    const colorGroups = { noColor: [] };
    const colorOptionIndex = productData.options.indexOf("Color");


    productData.media.forEach((media) => {
      if (colorOptionIndex !== -1 && media.alt) {
        const colorValue = media.alt.toLowerCase();
        if (!colorGroups[colorValue]) {
          colorGroups[colorValue] = [];
        }
        colorGroups[colorValue].push(media);
      } else {
        colorGroups.noColor.push(media);
      }
    });


    return colorGroups;
  };


  const getVariantIdForMedia = (productData, media) => {
    if (!media || !productData.variants) return null;
    const variant = productData.variants.find(
      (v) => v.featured_image && v.featured_image.src === media.src
    );
    return variant ? variant.id : null;
  };


const makePictureHtml = (media, cssClass, isEager = false) => {
  if (!media) return "";
  const loadingAttr = isEager ? "" : 'loading="lazy" decoding="async"';
  return `
    <picture>
      <source media="(max-width:600px)" srcset="${media.src}?width=500 1x, ${media.src}?width=1000 2x, ${media.src}?width=1500 3x" ${loadingAttr}>
      <source media="(max-width:1600px)" srcset="${media.src}?width=600 1x, ${media.src}?width=1200 2x" ${loadingAttr}>
      <source media="(max-width:2000px)" srcset="${media.src}?width=600 1x, ${media.src}?width=1200 2x" ${loadingAttr}>
      <img
        src="${media.src}?width=800"
        class="${cssClass}"
        alt="${media.alt || ""}"
        ${loadingAttr}
      >
    </picture>
  `;
};


const updateImagesForColor = (card, mediaItems, productData, selectedVariant, productHandle) => {
  const imageLink = card.querySelector(".product-card__image-link.js-product-link");
  if (!imageLink) return;

  let mainMedia = null;
  let hoverMedia = null;

  if (mediaItems && mediaItems.length > 1) {
    mainMedia = mediaItems[0];
    hoverMedia = mediaItems[1];
  } else if (mediaItems && mediaItems.length === 1) {
    mainMedia = mediaItems[0];
    hoverMedia = null;
  } else if (selectedVariant && selectedVariant.featured_media) {
    let mediaIndex = 0;
    for (let i = 0; i < productData.media.length; i++) {
      if (productData.media[i].id === selectedVariant.featured_media.id) {
        mediaIndex = i;
        break;
      }
    }
    mainMedia = productData.media[mediaIndex] || null;
    hoverMedia = productData.media.length > mediaIndex + 1
      ? productData.media[mediaIndex + 1]
      : null;
  } else {
    mainMedia = productData.media[0] || null;
    hoverMedia = productData.media[1] || null;
  }

  if (hoverMedia) {
    imageLink.classList.add("has-multiple-media");
    imageLink.classList.remove("has-multiple-media-reverse");
  } else {
    imageLink.classList.remove("has-multiple-media");
    imageLink.classList.remove("has-multiple-media-reverse");
  }

  const variantUrl = `/products/${productHandle}?variant=${selectedVariant?.id || productData.variants[0]?.id || ""}`;
  imageLink.href = variantUrl;
  imageLink.innerHTML =
    makePictureHtml(mainMedia, "product-card__primary-image", true) +
    makePictureHtml(hoverMedia, "product-card__hover-image", false);

  const selectedColorValue = card.querySelector(".pd-selected-color-value");
  if (selectedColorValue && selectedVariant?.options) {
    const colorIndex = productData.options.findIndex(option => option.toLowerCase() === "color");
    if (colorIndex !== -1 && selectedVariant.options[colorIndex]) {
      selectedColorValue.innerText = selectedVariant.options[colorIndex];
    } else {
      selectedColorValue.innerText = "";
    }
  }
};


  const processProductCards = () => {
    document.querySelectorAll(".product-card").forEach((card) => {
      try {
        const productData = JSON.parse(
          card.querySelector("[data-product-json]").textContent
        );
        const colorSwatches = card.querySelectorAll(".color-swatch");
        const sizeSelector = card.querySelector(".size-selector");
        const priceWrapper = card.querySelector(".price-wrapper");
        const productHandle = card.dataset.productHandle;
        const productLink = card.querySelector(".js-product-link");
        const titleLink = card.querySelector(".product-card__title a");


        const colorGroups = groupMediaByColor(productData);
        let selectedColorValue = null;


        colorSwatches.forEach((swatch) => {
          if (swatch.dataset.colorValue === swatch.dataset.filteredColor) {
              swatch.classList.add('color-swatch--selected');
          } else {
              swatch.classList.remove('color-swatch--selected');
          }
          swatch.addEventListener("click", function () {
            if (this.disabled) return;


            const variantId = this.dataset.variantId;
            const colorValue = this.dataset.colorValue;
            selectedColorValue = colorValue;


            const selectedVariant =
              productData.variants.find(
                (v) => v.id == variantId && v.available
              ) || productData.variants.find((v) => v.id == variantId);


            if (!selectedVariant) return;


            updatePrice(card, productData, selectedVariant);


            if (sizeSelector) {
              updateSizeAvailability(productData, sizeSelector, colorValue);
            }


            // Update main image and hover image for selected color
            updateImagesForColor(
              card,
              colorGroups[colorValue.toLowerCase()],
              productData,
              selectedVariant,
              productHandle
            );


            const variantUrl = `/products/${productHandle}?variant=${selectedVariant.id}`;
            updateProductLinks(card, variantUrl);

            colorSwatches.forEach((s) =>
              s.classList.remove("color-swatch--selected")
            );
            this.classList.add("color-swatch--selected");
          });
        });


        if (sizeSelector) {
          sizeSelector.querySelectorAll(".size-btn").forEach((button) => {
            button.addEventListener("click", function (e) {
              e.preventDefault();
              if (this.disabled || !this.dataset.variantId) return;


              let colorValue = selectedColorValue;
              if (!colorValue && colorSwatches.length > 0) {
                const selectedSwatch = Array.from(colorSwatches).find(
                  (swatch) =>
                    swatch.classList.contains("color-swatch--selected")
                );
                colorValue = selectedSwatch
                  ? selectedSwatch.dataset.colorValue
                  : colorSwatches[0].dataset.colorValue;
              }


              const selectedVariant = findVariantForSize(
                productData,
                this,
                colorValue
              );
              if (selectedVariant) {
                addToCart(selectedVariant);
              }
            });
          });
        }
      } catch (error) {
        console.error("Error processing product card:", error);
      }
    });
  };


  const formatMoney = (cents) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    // Fallback: basic dollar formatting
    return '$' + (cents / 100).toFixed(2);
  };

  const updatePrice = (card, productData, selectedVariant) => {
    const priceWrapper = card.querySelector('.price-wrapper');
    if (!priceWrapper) return;

    const price          = selectedVariant.price;
    const compareAtPrice = selectedVariant.compare_at_price;
    const isPresidentsCup = card.hasAttribute('data-president-cup-product');

    let priceHtml = '';

    if (isPresidentsCup) {
      // Presidents Cup: 30% off original price (same as Liquid: times 70, divided_by 100)
      const pcPrice = Math.floor((price * 70) / 100);

      priceHtml = `
        <span class="price-regular">
          <span class="price-sale">${formatMoney(pcPrice)}</span>
          <span class="price-compare-at">${formatMoney(price)}</span>
          <div class="saved__money">Save 30%</div>
        </span>`;
    } else if (compareAtPrice && compareAtPrice > price) {
      // On sale: show sale price + strikethrough + savings badge
      const savedCents      = compareAtPrice - price;
      const savedPercentage = Math.round((savedCents * 100) / compareAtPrice);

      priceHtml = `
        <span class="price-regular">
          <span class="price-sale">${formatMoney(price)}</span>
          <span class="price-compare-at">${formatMoney(compareAtPrice)}</span>
          <div class="saved__money">Save ${savedPercentage}%</div>
        </span>`;
    } else {
      // Standard price
      priceHtml = `
        <span class="price-regular">
          <span class="price-standard">${formatMoney(price)}</span>
        </span>`;
    }

    priceWrapper.innerHTML        = priceHtml;
    priceWrapper.dataset.variantId = selectedVariant.id;
  };


  const updateSizeAvailability = (productData, sizeSelector, colorValue) => {
    const sizeButtons = sizeSelector.querySelectorAll(".size-btn");
    const sizeOptionIndex = productData.options.indexOf("Size");
    const colorOptionIndex = productData.options.indexOf("Color");


    if (sizeOptionIndex === -1 || colorOptionIndex === -1) return;


    const availableSizes = productData.variants
      .filter((v) => v.options[colorOptionIndex] === colorValue && v.available)
      .map((v) => v.options[sizeOptionIndex]);


    sizeButtons.forEach((button) => {
      const sizeValue = button.dataset.sizeValue;
      const isAvailable = availableSizes.includes(sizeValue);
      const sizeVariant = productData.variants.find(
        (v) =>
          v.options[colorOptionIndex] === colorValue &&
          v.options[sizeOptionIndex] === sizeValue
      );


      button.classList.toggle("size-btn--disabled", !isAvailable);
      button.disabled = !isAvailable;
      button.setAttribute(
        "aria-label",
        isAvailable ? sizeValue : `${sizeValue} (Out of stock)`
      );
      if (sizeVariant) {
        button.dataset.variantId = sizeVariant.id;
        button.dataset.variantUrl = `/products/${productData.handle}?variant=${sizeVariant.id}`;
      }
    });
  };


  const updateProductLinks = (card, url) => {
    const productLink = card.querySelector(".js-product-link");
    const titleLink = card.querySelector(".product-card__title a");
    const slideLinks = card.querySelectorAll(".swiper-slide a");
    const singleMediaLink = card.querySelector(".single-media a");


    if (productLink) productLink.href = url;
    if (titleLink) titleLink.href = url;
    if (slideLinks.length) {
      slideLinks.forEach((link) => {
        link.href = url;
      });
    }
    if (singleMediaLink) singleMediaLink.href = url;
  };


  const findVariantForSize = (productData, button, selectedColorValue) => {
    const colorOptionIndex = productData.options.indexOf("Color");
    const sizeOptionIndex = productData.options.indexOf("Size");
    const sizeValue = button.dataset.sizeValue;


    if (colorOptionIndex !== -1 && sizeOptionIndex !== -1) {
      let colorValue = selectedColorValue;
      if (!colorValue) {
        const availableColors = productData.variants
          .filter((v) => v.available)
          .map((v) => v.options[colorOptionIndex])
          .filter((v, i, a) => a.indexOf(v) === i);
        colorValue =
          availableColors[0] ||
          productData.variants[0].options[colorOptionIndex];
      }


      return (
        productData.variants.find(
          (v) =>
            v.options[colorOptionIndex] === colorValue &&
            v.options[sizeOptionIndex] === sizeValue &&
            v.available
        ) ||
        productData.variants.find(
          (v) =>
            v.options[colorOptionIndex] === colorValue &&
            v.options[sizeOptionIndex] === sizeValue
        )
      );
    }


    return productData.variants.find((v) => v.id == button.dataset.variantId);
  };


  const addToCart = (variant) => {
    const miniCart =
      document.querySelector("store-cart-drawer") ||
      document.querySelector("mini-cart") ||
      document.querySelector("cart-drawer");
    const formData = new FormData();
    formData.append("id", variant.id);
    formData.append("quantity", 1);


    if (miniCart?.getSectionsToRender) {
      formData.append(
        "sections",
        miniCart.getSectionsToRender().map((section) => section.id)
      );
    }
    formData.append("sections_url", window.location.pathname);
    document.body.classList.add("adding-to-cart");
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        // if (response.status) {
        //   if (typeof publish === "function") {
        //     publish(PUB_SUB_EVENTS.cartError, {
        //       source: "size-swatch",
        //       productVariantId: variant.id,
        //       errors: response.errors || response.description,
        //     });
        //   }
        //   throw new Error(response.errors || response.description);
        // }


        if (miniCart?.renderContents) {
          miniCart.renderContents(response);
        }


        if (miniCart?.open) {
          miniCart.classList.remove("is-empty");
          miniCart.open();
        }


        if (typeof publish === "function") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "size-swatch",
            productVariantId: variant.id,
          });
        }
      })
      .catch((error) => {
        console.error("Add to cart failed:", error);
      })
      .finally(() => {
        // Remove loading class
        document.body.classList.remove("adding-to-cart");
      });
  };


  // const initializeColorSwatches = () => {
  //   const swatchContainers = document.querySelectorAll('.color-swatches');
  //   swatchContainers.forEach(container => {
  //     const swiperElement = container.querySelector('.swiper');
  //     if (swiperElement) {
  //       new Swiper(swiperElement, {
  //         slidesPerView: "auto",
  //         spaceBetween: 10,
  //         freeMode: true,
  //         a11y: false,
  //         navigation: {
  //           nextEl: container.querySelector('.swiper-button-next'),
  //           prevEl: container.querySelector('.swiper-button-prev'),
  //         },
  //         on: {
  //           init: function () {
  //             const nextButton = container.querySelector('.swiper-button-next');
  //             const prevButton = container.querySelector('.swiper-button-prev');


  //             const checkLockClasses = () => {
  //               if (nextButton.classList.contains('swiper-button-lock') && 
  //                   prevButton.classList.contains('swiper-button-lock')) {
  //                 container.classList.add('no-padding');
  //               } else {
  //                 container.classList.remove('no-padding');
  //               }
  //             };


  //             checkLockClasses();


  //             const observer = new MutationObserver(checkLockClasses);
  //             observer.observe(nextButton, { attributes: true, attributeFilter: ['class'] });
  //             observer.observe(prevButton, { attributes: true, attributeFilter: ['class'] });
  //           },
  //         },
  //       });
  //     }
  //   });
  // };
  const initializeColorSwatches = () => {
    const swatchContainers = document.querySelectorAll('.color-swatches');
    swatchContainers.forEach(container => {
      const swiperElement = container.querySelector('.swiper');
      if (swiperElement) {
        new Swiper(swiperElement, {
          slidesPerView: "auto",
          spaceBetween: 10,
          freeMode: true,
          a11y: false,
          mousewheelControl: true,
          navigation: {
            nextEl: container.querySelector('.swiper-button-next'),
            prevEl: container.querySelector('.swiper-button-prev'),
          },
          on: {
            init: function () {
              const nextButton = container.querySelector('.swiper-button-next');
              const prevButton = container.querySelector('.swiper-button-prev');


              const checkLockClasses = () => {
                if (nextButton.classList.contains('swiper-button-lock') && 
                    prevButton.classList.contains('swiper-button-lock')) {
                  container.classList.add('no-padding');
                } else {
                  container.classList.remove('no-padding');
                }
              };


              checkLockClasses();


              const observer = new MutationObserver(checkLockClasses);
              observer.observe(nextButton, { attributes: true, attributeFilter: ['class'] });
              observer.observe(prevButton, { attributes: true, attributeFilter: ['class'] });
              setTimeout(() => {
        // Find button where both attributes have the SAME value
        const targetButton = Array.from(
          swiperElement.querySelectorAll('button.color-swatch')
        ).find(button => {
          const colorValue = button.getAttribute('data-color-value');
          const filteredColor = button.getAttribute('data-filtered-color');
          return colorValue && filteredColor && colorValue === filteredColor;
        });

        if (targetButton) {
          const slideElement = targetButton.closest('.swiper-slide');

          if (slideElement) {
            const allSlides = Array.from(swiperElement.querySelectorAll('.swiper-slide'));
            const slideIndex = allSlides.indexOf(slideElement);

            if (slideIndex !== -1) {
              this.slideTo(slideIndex, 500);   // 500ms smooth slide
            }
          }
        }
      }, 150); // Small delay ensures Swiper is ready
            },
          },
        });
      }
    });
  };



  

  if (document.readyState !== "loading") {
    processProductCards();
    initializeColorSwatches();
    // initializeQuickViewButtons();
  } else {
    document.addEventListener("DOMContentLoaded", processProductCards);
    document.addEventListener("DOMContentLoaded", initializeColorSwatches);
    // document.addEventListener("DOMContentLoaded", initializeQuickViewButtons);
  }
};


window.cardProductFunc();
// Also called on mclbx-custom-js.js line 183